<template>
  <div class="container">
    <div class="row mt-3">
      <div class="col-md-9 col-xs-12 mb-4">
        <img src="~@/assets/logo.png" alt="Khushnaveesi" height="40" />
      </div>
      <!-- <div class="col-md-3 col-xs-12">
        <ul class="nav">
          <li class="nav-item">
            <a class="nav-link active" href="#">editor</a>
          </li>
          <li class="nav-item">
            <a class="nav-link link-secondary" aria-current="page" href="#">send feedback</a>
          </li>
        </ul>
      </div>-->
    </div>
    <div id="app">
      <text-to-image />
    </div>
  </div>
</template>

<script>
import TextToImage from "./components/TextToImage.vue";

export default {
  name: "App",
  components: {
    TextToImage,
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_font.scss";
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  unicode-bidi: bidi-override !important;
}
</style>
